import React from 'react'

function GripStrengthTest() {
  return (
    <main>
        <h1>Hand Grip Test For Muscular Strength</h1>

    </main>
  )
}

export default GripStrengthTest